// @flow
/**
 * By given query, tarnsforems object and map of allowed fields
 * normalize given query and return new query object.
 * It will ignore query fields which is not exists in allowedQueries (if
 * this map presented). Also it will try to find a transformerm in given
 * transformers object by the key and if it exists it will add to the result
 * query only values that returned by the transformer.
 * Otherwise it will just set value from old query to the new one.
 * @param  {Object} query
 * @param  {Object} transformers
 * @param  {Object} allowedQueries
 * @return {Object}
 * @private
 */
export default function normalize(
  query: Object,
  transformers?: Object,
  allowedQueries?: Object
): Object {
  const reducer = (filtered: Object, key: string): Object => {
    if (transformers && key in transformers) {
      return {
        ...filtered,
        ...(transformers[key](query[key]) || {}),
      }
    }
    if (!allowedQueries || key in allowedQueries) {
      return {
        ...filtered,
        [key]: query[key],
      }
    }

    return filtered
  }

  return Object.keys(query).reduce(reducer, {})
}
